import { render } from "./Proterties.vue?vue&type=template&id=507d8f16&scoped=true"
import script from "./Proterties.vue?vue&type=script&lang=js"
export * from "./Proterties.vue?vue&type=script&lang=js"

import "./Proterties.vue?vue&type=style&index=0&id=507d8f16&scoped=true&lang=less"

import exportComponent from "E:\\MyProject\\crash-webfrontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507d8f16"]])

export default __exports__